(
    function (skyward, $, undefined) 
    {
        skyward.familyentityconfigcontrols = skyward.familyentityconfigcontrols || {};

        var init = function (selector) {
            // active on change
            var reportCardDisplaySelector = $(selector).find("#editFamilyAccessReportCardDisplay");

            if (reportCardDisplaySelector.length > 0) {
                var useForFlag = $(selector).find('input[type=checkbox]');

                var useForOnChange = function () { skyward.familyentityconfigcontrols.useForChanged($(this)); };
                useForFlag.on('change', useForOnChange);
            };

            var familyAutoApproveButton = $(selector).find('#editFamilyAccessChangeRequest_btnSelectAllFamilyChangeRequestAutoApprove');
            var familyApprovalNeededButton = $(selector).find('#editFamilyAccessChangeRequest_btnSelectAllFamilyChangeRequestApprovalNeeded');
            var familyReadOnlyButton = $(selector).find('#editFamilyAccessChangeRequest_btnSelectAllFamilyChangeRequestReadOnly');
            var studentAutoApproveButton = $(selector).find('#editFamilyAccessChangeRequest_btnSelectAllStudentChangeRequestAutoApprove');
            var studentApprovalNeededButton = $(selector).find('#editFamilyAccessChangeRequest_btnSelectAllStudentChangeRequestApprovalNeeded');
            var studentReadOnlyButton = $(selector).find('#editFamilyAccessChangeRequest_btnSelectAllStudentChangeRequestReadOnly');

            familyAutoApproveButton.on('click', selectAllAutoApproveFamily);
            familyApprovalNeededButton.on('click', selectAllAutoApproveFamily);
            familyReadOnlyButton.on('click', selectAllAutoApproveFamily);
            studentAutoApproveButton.on('click', selectAllAutoApproveFamily);
            studentApprovalNeededButton.on('click', selectAllAutoApproveFamily);
            studentReadOnlyButton.on('click', selectAllAutoApproveFamily);
        };

        skyward.familyentityconfigcontrols.useForChanged = function (checkbox) 
        {
            var useForValue = skyward.controls.getValue(checkbox);

            if (useForValue == false) 
            {
                var row = checkbox.closest('tr');
                var id = checkbox.attr('id').split("-")[2];
                var object = checkbox.attr('id').split("-")[1];
                var gradLow = $(row).find('#FamilyAccessDisplayGradYearLow-' + object + '-' + id);
                var gradHigh = $(row).find('#FamilyAccessDisplayGradYearHigh-' + object + '-' + id);
                var originalLow = skyward.controls.getOriginalValue(gradLow);
                var originalHigh = skyward.controls.getOriginalValue(gradHigh);
                skyward.controls.setValue(gradLow, originalLow, true);
                skyward.controls.setValue(gradHigh, originalHigh, true);

                var listOfDirty = [];
                listOfDirty.push(gradLow);
                listOfDirty.push(gradHigh);

                skyward.changeTracking.removeFromDirtyList(listOfDirty);
            }
        };

        var selectAllAutoApproveFamily = function () {
            var buttonClicked = $(this);
            var buttonID = buttonClicked.attr('id');
            var familyPrefix = 'editFamilyAccessChangeRequest_ChangeRequestFamily';
            var studentPrefix = 'editFamilyAccessChangeRequest_ChangeRequestStudent';
            switch (buttonID) {
                case "editFamilyAccessChangeRequest_btnSelectAllFamilyChangeRequestAutoApprove":
                    setAllOptions(familyPrefix, 'A');
                    break;
                case "editFamilyAccessChangeRequest_btnSelectAllFamilyChangeRequestApprovalNeeded":
                    setAllOptions(familyPrefix, 'N');
                    break;
                case "editFamilyAccessChangeRequest_btnSelectAllFamilyChangeRequestReadOnly":
                    setAllOptions(familyPrefix, 'R');
                    break;
                case "editFamilyAccessChangeRequest_btnSelectAllStudentChangeRequestAutoApprove":
                    setAllOptions(studentPrefix, 'A');
                    break;
                case "editFamilyAccessChangeRequest_btnSelectAllStudentChangeRequestApprovalNeeded":
                    setAllOptions(studentPrefix, 'N');
                    break;
                case "editFamilyAccessChangeRequest_btnSelectAllStudentChangeRequestReadOnly":
                    setAllOptions(studentPrefix, 'R');
                    break;
            }
        };

        var setAllOptions = function (radioIDPrefix, radioCodeValue) {
            var radioSelector = 'input[id^="' + radioIDPrefix + '"]';
            $(radioSelector).each(function () {
                var currentRadioButtonGroup = $(this);

                skyward.controls.setValue(currentRadioButtonGroup, radioCodeValue);
            });
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);